// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PropertySafetyOutlinedSvg from "@ant-design/icons-svg/es/asn/PropertySafetyOutlined";
import AntdIcon from '../components/AntdIcon';

var PropertySafetyOutlined = function PropertySafetyOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyOutlinedSvg
  }));
};

PropertySafetyOutlined.displayName = 'PropertySafetyOutlined';
export default React.forwardRef(PropertySafetyOutlined);